import React, { Component } from 'react';
import FilterBasic from '../../basicElement/FilterBasic';
import API_URL from '../../../common/url';

class PositiontFilter extends Component {
    handleChange = (params, key) => {
        if (key === 'enterpriseDepartmentId') {
            params.position = null;
            params.positionId = '';
            params.xjDept = null;
            params.xjDeptId = '';
            params.xjDeptName = '';
            params.xxjDept = null;
            params.xxjDeptId = '';
            params.xxjDeptName = '';
        }  else if (key === 'xjDept') {
            params.xxjDept = null;
            params.xxjDeptId = '';
            params.xxjDeptName = '';
        }
        this.props.onChange(params);
    }

    render() {
        const { params, onChange, enterpriseDepartmentList, ...rest } = this.props;
        const { enterpriseDepartmentId, xjDeptId } = params;
        const filters = [{
            name: '部门',
            key: 'enterpriseDepartmentId',
            type: 'select',
            typeProperty: {
                style: {width: 140},
                list: enterpriseDepartmentList,
            }
        }, {
            name: '下级组织',
            key: 'xjDept',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入下级组织检索',
                params: {limit: 20, level: 5, parentId: enterpriseDepartmentId },
                url: API_URL.user.queryUserDepartmentSelect,
                config: { id: 'enterpriseDepartmentId', name: 'enterpriseDepartmentName' }
            }
        }, {
            name: '下下级组织',
            key: 'xxjDept',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入下下级组织检索',
                params: {limit: 20, level: 6, parentId: xjDeptId},
                url: API_URL.user.queryUserDepartmentSelect,
                config: { id: 'enterpriseDepartmentId', name: 'enterpriseDepartmentName' }
            }
        }, {
            name: '职位级别',
            key: 'position',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'positionName',
                disabled: !enterpriseDepartmentId,
                style: {width: 140},
                placeholder: '输入职位检索',
                params: {limit: 20, enterpriseDepartmentId: xjDeptId ? xjDeptId : enterpriseDepartmentId},
                url: API_URL.team.queryUserPositionSelect,
                config: { id: 'positionId', name: 'positionName' }
            }
        }, {
            name: '对应角色',
            key: 'roleCode',
            type: 'input',
        }];
        return (
            <FilterBasic filters={filters} params={params} onChange={this.handleChange} {...rest} />
        )
    }
}

export default PositiontFilter;


// WEBPACK FOOTER //
// ./src/components/documentManagement/departmentalDocuments/PositiontFilter.js